import React from 'react'

import { VerifyCodeContent } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'

export const VerifyCodeWrapper: React.FC = () => {
  const {
    activeScreen,
    hostServices,
    isInPortal,
    logger,
    navigateToLogin,
  } = useTransmit()

  if (activeScreen.type !== 'VerifyCode') {
    return null
  }

  return (
    <VerifyCodeContent
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...activeScreen.payload}
      hostServices={hostServices}
      isInPortal={isInPortal}
      logger={logger}
      navigateToLogin={navigateToLogin}
    />
  )
}
